import { TitleCasePipe } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { TypographyComponent } from 'components';
import { AiSummarySignal } from '@brand-lolly/app/social-media-influencer/modules/social-listening/models/social-listening-ai-summary.model';

@Component({
	standalone: true,
	selector: 'app-ai-summary-signal-card',
	imports: [TitleCasePipe, TypographyComponent],
	templateUrl: './ai-summary-signal-card.component.html',
	styleUrls: ['./ai-summary-signal-card.component.scss']
})
export class AiSummarySignalCardComponent implements OnChanges {
	@Input() signal!: AiSummarySignal;

	sourceLabel: string = '';

	private static readonly SOURCE_LABELS: Record<string, string> = {
		mentions: 'mentions',
		reviews: 'reviews',
		both: 'mentions + reviews'
	};

	ngOnChanges(): void {
		this.sourceLabel =
			AiSummarySignalCardComponent.SOURCE_LABELS[this.signal.source] ??
			this.signal.source;
	}
}
